import React from "react";

import { CommentBox } from "@src/components/note/comment_box";
import { Note } from "@src/types";
import "./comments_overview.less";
import { useAgGrid } from "@src/hooks/use_ag_grid";
import { useNoteHook } from "@src/hooks/note_hook";
import { useLocation } from "react-router-dom";

interface CommentsOverviewProps {
  notes?: Note[];
  requestId: number;
}

const CommentsOverview: React.FC<CommentsOverviewProps> = ({ requestId }) => {
  let gridApiRef = null;
  const location = useLocation();

  if (location.pathname !== "/staffing/teamOverview") {
    const { gridApi } = useAgGrid();
    gridApiRef = gridApi;
  }

  const { notes } = useNoteHook({
    requestId: requestId,
    gridApi: gridApiRef,
  });

  return (
    <div className="comments-overview">
      {notes?.map((note: Note) => (
        <CommentBox key={note.id} note={note} />
      ))}
      {notes?.length === 0 && (
        <div className="no-comments-message">
          <p>No comments yet</p>
        </div>
      )}
    </div>
  );
};

export default CommentsOverview;
